import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const ArrowTopRight: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M12.5968 10.0194C13.1101 10.0136 13.4969 9.5979 13.4988 9.08467C13.5067 6.93647 13.4724 5.35833 13.4838 3.44388C13.4868 2.93256 13.0711 2.51587 12.5598 2.51804C10.409 2.52714 8.82617 2.49076 6.90708 2.50228C6.39826 2.50533 5.98739 2.92879 5.9826 3.4376C5.97765 3.96328 6.40401 4.37971 6.92971 4.38201C8.16233 4.3874 9.01825 4.41275 10.2821 4.40633L3.28102 11.4075C2.9178 11.7707 2.91775 12.3596 3.28091 12.7229C3.64416 13.0862 4.23323 13.0863 4.59655 12.723L11.5974 5.72209C11.5852 7.11663 11.6198 7.91855 11.622 9.07573C11.623 9.59854 12.0741 10.0253 12.5968 10.0194Z" />
  </SvgIcon>
);
